import { Component, Input, OnInit } from '@angular/core';
import { FormatCurrencyHelper } from 'app/core/helpers/format-currency-helper';

@Component({
  selector: 'app-custom-footer-grid',
  templateUrl: './custom-footer-grid.component.html',
  styleUrls: ['./custom-footer-grid.component.scss']
})
export class CustomFooterGridComponent implements OnInit {
  @Input() hasGrouped = false;
  @Input() displayedRowCount = 0;
  @Input() displayedGroupCount = 0;
  @Input() totalRows = 0;
  @Input() itemSelected = 0;
  @Input() totalAmountSelected = 0;
  @Input() totalLabel = null;
  @Input() totalLabelDisplayedGroup = 'Group/s';
  @Input() totalLabelDisplayedRowCount = 'of';
  @Input() totalLabelRow = 'records found';
  @Input() verticalAlign = 'flex-start';
  @Input() widthValue = '60%';
  @Input() totalLists: { totalLabel: string, totalAmountSelected: number } [] = [];

  constructor() { }

  ngOnInit(): void {
  }

  formatCurrencyText(valueFormated): string {
    const formatVal = isNaN(Number(valueFormated)) ? 0 : Number(valueFormated);
    return FormatCurrencyHelper.formatCurrency(formatVal);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/custom-footer-grid/custom-footer-grid.component.ts